import React from "react";
import { withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { getInviteByToken } from "../actions";
import { getLocationParam, resolveErrorMessage } from "../util";

import InviteMessage from "./components/RegisterForm/InviteMessage";
import OnboardingForm from "./components/RegisterForm/OnboardingForm";
import LoadingSpinner from "./components/LoadingSpinner";
import LuxLogo from "./components/LuxLogo";
import { Box, Fade, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "100vh",
    padding: 16,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: 500,
    padding: 16,
  },
}));

const RegisterContent = ({ token, history }) => {
  const [invite, setInvite] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }

    const loadInvite = async () => {
      try {
        const data = await getInviteByToken(token);
        setInvite(data);
      } catch (e) {
        const errorMessage = resolveErrorMessage(e);
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    loadInvite();
  }, [token]);

  if (loading) return <LoadingSpinner fade message={<FormattedMessage id="app.loading.fetching" />} />;

  if (!token) return <InviteMessage title={<FormattedMessage id="app.invite.onboarding.required.title" />} message={<FormattedMessage id="app.invite.onboarding.required.message" />} />;

  if (error) return <InviteMessage title={<FormattedMessage id="app.invite.onboarding.error.title" />} message={error} />;

  if (!invite) return <InviteMessage title={<FormattedMessage id="app.invite.onboarding.notFound.title" />} message={<FormattedMessage id="app.invite.onboarding.notFound.message" />} />;

  return (
  <Fade in timeout={900}>
    <div>
      <OnboardingForm invite={invite} history={history} />
    </div>
  </Fade>
  );
};

const Register = ({ location, history }) => {
  const classes = useStyles();
  const token = getLocationParam(location, "token");

  return (
    <Box className={classes.container}>
      <Box className={classes.content}>
        <LuxLogo />
        <RegisterContent token={token} history={history} />
      </Box>
    </Box>
  );
};

export default withRouter(Register);
